import * as React from "react";
import Header from "../components/header/header"
import Footer from "../components/footer/footer"
import { Script } from "gatsby"



export default function Layout( props ) {

	const [cDeco, setCDeco] = React.useState('');
	const [singleSSS, setSingleSSS] = React.useState('');

	React.useEffect(() => {

		if(props?.path === '/expertise/' || props?.path === '/' || props?.path === '/news-ideas/' || props?.path === '/locations/'){
			setCDeco('c-deco');
		} else {
			setCDeco('');
		}

		if( (props?.data?.wpSector && props?.data?.wpSector !== null) || props?.path === '/about/' || (props?.data?.wpService && props?.data?.wpService !== null) || (props?.data?.wpSolution && props?.data?.wpSolution !== null)){
			setSingleSSS('gray-bgr');
		} else {
			setSingleSSS('');
		}

	},[props?.path]);

	return (
		<>

			<main className={`animation-fade-container site-main ${cDeco} ${singleSSS}`}>
				<Header alias="header" location={props?.path} dataProps={props?.data} />
					{props.children}
				<Footer alias="footer" />
			</main>
		</>

	);
}

